import { useLanguage } from '../context/LanguageContext';

export const WhatsAppButton = () => {
  const { t, language } = useLanguage();
  const phoneNumber = '5511936205854';
  const message = encodeURIComponent(t.whatsapp.message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group fixed bottom-4 right-4 z-[90] hidden items-center md:flex md:flex-col"
      aria-label={language === 'pt' ? 'Abrir conversa no WhatsApp' : 'Open WhatsApp conversation'}
    >
      <img
        src="/carlinhos-wave.png"
        alt="Carlinhos"
        className="h-auto w-[200px] object-contain drop-shadow-[0_20px_32px_rgba(6,182,212,0.3)] transition-transform duration-300 group-hover:-translate-y-1"
      />
      <span className="mt-1 text-center text-xs font-semibold tracking-wide text-cyan-300">
        {language === 'pt' ? 'Chama no WhatsApp!' : 'Chat on WhatsApp!'}
      </span>
    </a>
  );
};
